import React, { useState } from "react";
import MenuIcon from "@mui/icons-material/Menu";
import DashboardIcon from "@mui/icons-material/BarChart";
import WorkIcon from "@mui/icons-material/WorkOutline";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PersonIcon from "@mui/icons-material/Person";
import LogoutIcon from "@mui/icons-material/Logout";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { useLocation } from "react-router-dom";
import SidebarItem from "./SidebarItem";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const sidebarItems = [
  {
    label: "Overview",
    icon: <DashboardIcon />,
    href: "/vendorportal/dashboard",
  },
  {
    label: "Jobs",
    icon: <WorkIcon />,

    dropdown: true,
    children: [
      { label: "Ongoing", href: "/vendorportal/jobs/ongoing" },
      { label: "Opportunities", href: "/vendorportal/jobs/opportunities" },
      { label: "Upcoming", href: "/vendorportal/jobs/upcoming" },
      { label: "Completed", href: "/vendorportal/jobs/completed" },
    ],
  },
  {
    label: "Money",
    icon: <AttachMoneyIcon />,
    href: "/vendorportal/money",
  },
  {
    label: "Profile",
    icon: <PersonIcon />,
    href: "/vendorportal/profile",
  },
  // {
  //   label: "Settings",
  //   icon: <SettingsIcon />,
  //   href: "/vendorportal/settings",
  // },
  // {
  //   label: "Support",
  //   icon: <HelpOutlineIcon />,
  //   href: "/vendorportal/support",
  // },
  {
    label: "Logout",
    icon: <LogoutIcon />,
    isLogout: true,
  },
];

const VendorDashboardSidebar = ({
  isExpanded,
  toggleSidebar,
  setIsSidebarExpanded,
}) => {
  const { vendorProfileDetails } = useSelector((state) => state.vendorProfile);
  const location = useLocation();
  const navigate = useNavigate();

  const [openDropdowns, setOpenDropdowns] = useState({});

  const toggleDropdown = (label) => {
    setOpenDropdowns((prev) => ({
      ...prev,
      [label]: !prev[label],
    }));
  };

  const handleLogout = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You will be logged out!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, logout!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem("vendorToken");
        localStorage.removeItem("vendorId");
        localStorage.removeItem("vendorPhone");
        navigate("/vendorportal");
      }
    });
  };

  return (
    <div
      className={`fixed top-0 left-0 h-screen bg-white border-r shadow transition-all duration-300 ${
        isExpanded ? "w-64" : "w-20"
      }`}
    >
      <div className="flex items-center justify-center w-full p-4">
        {isExpanded && (
          <div className=" flex justify-start items-center w-full">
            <h1 className="text-2xl text-black font-bold">Vendor Portal</h1>
          </div>
        )}
        <button onClick={toggleSidebar}>
          {isExpanded ? <CloseRoundedIcon /> : <MenuIcon />}
        </button>
      </div>

      <nav className="mt-2 space-y-1 text-base">
        {sidebarItems.map((item) =>
          item.isLogout ? (
            <div
              key={item.label}
              onClick={handleLogout}
              className={`flex items-center justify-center cursor-pointer px-4 py-2 hover:bg-gray-100 transition-all text-black`}
            >
              <div className="text-xl">{item.icon}</div>
              {isExpanded && (
                <span className="ml-3 text-lg font-medium flex-1">
                  {item.label}
                </span>
              )}
            </div>
          ) : (
            <SidebarItem
              key={item.label}
              icon={item.icon}
              label={item.label}
              isExpanded={isExpanded}
              hasDropdown={item.dropdown}
              isOpen={openDropdowns[item.label]}
              toggleOpen={() => toggleDropdown(item.label)}
              childrenData={item.children}
              href={item.href}
              currentPath={location.pathname}
              setIsSidebarExpanded={setIsSidebarExpanded}
            />
          )
        )}
      </nav>
    </div>
  );
};

export default VendorDashboardSidebar;
